import React from 'react';

function VideoCamera(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M15.125 6H2.625C2.27982 6 2 6.27982 2 6.625V17.875C2 18.2202 2.27982 18.5 2.625 18.5H15.125C15.4702 18.5 15.75 18.2202 15.75 17.875V6.625C15.75 6.27982 15.4702 6 15.125 6ZM14.5 7.24983V17.2498H3.25V7.24983H14.5Z"
        fillRule="evenodd"
      />
      <path d="M21.4072 7.82249C21.0384 7.59475 20.5779 7.57447 20.1905 7.76892L17.3456 9.19095L17.2585 9.24359C17.0146 9.4197 16.9271 9.75156 17.0659 10.0294C17.2203 10.3382 17.5957 10.4634 17.9044 10.309L20.7504 8.88605L20.75 15.6133L17.9044 14.191L17.8101 14.1529C17.5228 14.0635 17.2048 14.1927 17.0659 14.4706C16.9116 14.7793 17.0368 15.1547 17.3456 15.309L20.1914 16.7315L20.3231 16.7881C20.6802 16.9179 21.0801 16.8789 21.4075 16.6764C21.7758 16.4486 22 16.0464 22 15.6133V8.88583L21.9919 8.74283C21.9487 8.36556 21.735 8.02492 21.4072 7.82249Z" />
    </svg>
  );
}

export default VideoCamera;
